module.exports = __webpack_public_path__ + "img/left.f1c631b4.jpg";